import { useState, useEffect } from 'react';
import { API_URL } from '../utils/gameUtils';

export const useUser = () => {
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState("Guest");
  const [highScores, setHighScores] = useState([]);

  const createUser = async () => {
    try {
      const res = await fetch(`${API_URL}/users`, { method: 'POST' });
      if (res.ok) {
        const data = await res.json();
        const newId = data.id;
        localStorage.setItem('kotobattle_user_id', newId);
        setUserId(newId);
        setUserName(data.username || "Guest");
      }
    } catch (e) {
      console.error("Failed to connect to backend", e);
    }
  };

  // 1. 初回ロード時にユーザーIDを確認・取得
  useEffect(() => {
    const initUser = async () => {
      let id = localStorage.getItem('kotobattle_user_id');
      
      // IDがなければ新規作成
      if (!id) {
        await createUser();
      } else {
        // 既存ユーザー情報の取得
         try {
          const res = await fetch(`${API_URL}/users/${id}`);
          if (res.ok) {
            const data = await res.json();
            setUserName(data.username);
            setUserId(id);
            fetchHighScores(id);
          } else if (res.status === 404) {
              console.warn("User ID not found in DB, creating new user...");
              localStorage.removeItem('kotobattle_user_id');
              await createUser();
          }
        } catch (e) {
          console.error("Failed to fetch user info", e);
        }
      }
    };
    initUser();
  }, []);

  // ハイスコア（履歴）取得
  const fetchHighScores = async (id) => {
    try {
      const res = await fetch(`${API_URL}/users/${id}/scores`);
      if (res.ok) {
        const data = await res.json();
        setHighScores(data);
      }
    } catch (e) {
      console.error("Failed to fetch scores", e);
    }
  };

  // ユーザー名更新
  const updateUserName = async (newName) => {
      if (!userId || !newName.trim()) return;
      try {
          const res = await fetch(`${API_URL}/users/${userId}`, {
              method: 'PUT',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ username: newName })
          });
          if (res.ok) {
              const data = await res.json();
              setUserName(data.username);
          }
      } catch (e) {
          console.error("Failed to update username", e);
      }
  };

  return { userId, userName, highScores, updateUserName, fetchHighScores };
};
